import { NavigationActions } from '../Navigation/NavigationActions';
import { extractProgressFromPageResponse } from '../../state';

/**
 * This reducer should listen to page change events and ensure the progress is up to date.
 */
const progressReducer = (state, action) => {
  if (action.type === NavigationActions.PAGE_REQUEST_COMPLETED) {
    const progress = extractProgressFromPageResponse(action.nextPage);

    const { total = 0, currentPage } = progress;

    const { total: previousTotal = 0 } = state?.pages?.progress || {};

    const newProgress = {
      total,
      reverse: total < previousTotal,
      currentPage
    };

    return {
      ...state,
      pages: {
        ...state.pages,
        progress: newProgress
      },
    };
  } else {
    return state;
  }
};

export default progressReducer;
